import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/system";
import { Table, Dropdown, Menu } from "antd";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import {
  downloadRequest,
  resetFilters,
  setLocationData,
  updatePaginationRequest,
} from "../../../store/actions/location";
import { DropdownFilterWithSearch, DropdownFilterWithSearchAndCheckbox } from "../../../components/DropdownFilter";
import LocationOptPopup from "../../../pages/LocationDetails/CreateLocation/LocationOptPopup";
import CreateLocation from "../../../pages/LocationDetails/CreateLocation";
import { fetchRequest, setCurrentModal, updateModal } from "../../../store/actions/location";
import CustomModal from "../../../components/CustomModal";
import { Button } from "@vds/buttons";
import ToastNotification from "../ToastNotification";
import { searchPopUpUpdate } from "../../../store/actions/globalSearch";
import { deleteLocationEndPoint } from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import InventoryLocationView from '../../../pages/LocationDetails/CreateLocation/inventoryLocationView';
import LocationPopupProvider from "../../../pages/LocationDetails/CreateLocation/LocationPopupProvider";

const LocationTable = (props) => {
  const {
    alarmCounts,
    setSelectedOrganization,
    setSelectedCloneOrganization,
    permissions,
    searchLoc,
    selectedOrganization,
    selectedCloneOrganization,
  } = props;
  const didInit = useRef(false);
  let { state } = useLocation();
  const { shouldUpdate, count, locationList, currentPage, pageSize, locationtype } =
    useSelector((state) => ({
      shouldUpdate: state.location.shouldUpdate,
      count: state.location.data.total,
      locationList: state.location.data.locations,
      currentPage: (state.location.filter.pageNo || 0) + 1,
      pageSize: state.location.filter.limit,
      locationtype: state.location.locationtype,
    }));

  const user = useSelector((state) => state.auth.user);

  const isLoading = useSelector((state) => state.location.isLoading);
  const currentModal = useSelector((state) => state.location.currentModal);

  const [searchAddress, setAddress] = useState(
    state?.hasOwnProperty("address") && state?.createlocation !== true
      ? [state?.address]
      : ""
  );
  const searchPopUpData = useSelector(
    (state) => state.globalSearch.navigateSearchPopUp
  );
  const resultState = state && state.id ? state : null;

  const [searchLocName, setSearchLocName] = useState(searchLoc);
  const [orgPopupVisible, setOrgPopupVisible] = useState(searchPopUpData);
  const [inventoryLocationView, setInventoryLocationView] = useState(false);
  const [inventoryLocationData, setInventoryLocationData] = useState({});
  const [notificationProps, setNotificationProps] = useState({});
  const [showNotification, setShowNotification] = useState(false);
  const [editConfirm, setEditConfirm] = useState(false);
  const [isAsc, setAsc] = useState(true);
  const location_data = useSelector(state => state.location.location_data);
  const current_modal = useSelector(state => state.location?.current_modal);

  useEffect(() => {
    if (current_modal == 'ShipmentLocation') {
      setOrgPopupVisible(true);
      setSelectedCloneOrganization(false);
    } else if (current_modal == '') {
      setOrgPopupVisible(false);
      setInventoryLocationView(false);
    } else if (current_modal == 'inventory_location_view') {
      setInventoryLocationView(true);
      setInventoryLocationData(location_data);
    }
  }, [current_modal]);

  const dispatch = useDispatch();
  const editLocation = (record) => {
    if (record?.createtype === 'inventory_location') {
      dispatch(setLocationData({ ...location_data, ...record, action_type: 'edit' }));
      dispatch(updateModal({ current_modal: 'inventory_location' }));
    } else {
      setSelectedOrganization(record);
      if (record) {
        setOrgPopupVisible(true);
        setSelectedCloneOrganization(false);
      }
    }
  };
  const locationDetails = (record) => {
    if (record?.createtype === 'inventory_location') {
      setInventoryLocationData(record);
      setInventoryLocationView(true);
    } else {
      setInventoryLocationData(record);
      setInventoryLocationView(true);

      // setSelectedOrganization(record);
      // setSelectedCloneOrganization(false);
      // setEditConfirm(true);
      // if (record) {
      //   setOrgPopupVisible(true);
      // }
    }
  };
  const cloneLocation = (record) => {
    if (record?.createtype === 'inventory_location') {
      dispatch(setLocationData({ ...location_data, ...record, name: '', action_type: 'Add', cloneAction: true }));
      dispatch(updateModal({ current_modal: 'inventory_location' }));
    } else {
      setSelectedOrganization(record);
      if (record) {
        setOrgPopupVisible(true);
        setSelectedCloneOrganization(true);
      }
    }
  };

  useEffect(() => {
    dispatch(updatePaginationRequest({
      limit: 10,
    }));
  }, []);

  useEffect(() => {
    didInit.current = false;
    dispatch(resetFilters());
  }, [dispatch, user?.accountId]);

  const handleSearchLocName = (e) => {
    setAsc(e?.isAsc);
    //setSearchLocName(e?.filteredResult);
    dispatch(
      updatePaginationRequest({
        name: { value: e?.filters?.text ? e?.filters?.text : "", sort: e?.isAsc ? "asc" : "desc" },
        pageNo: 0,
      })
    );
  };
  const handleLocFilterReset = () => {
    setSearchLocName("");
    //dispatch(fetchRequest());
    dispatch(
      updatePaginationRequest({
        name: { value: "", sort: "" },
        pageNo: 0,
      })
    );
  };

  const handleLocTypeChange = (e) => {
    setAsc(e?.isAsc);
    const selectedTypes = e?.filteredResult || [];
    const createtypeValue = selectedTypes.length === 1 ? selectedTypes[0] : "";
    dispatch(
      updatePaginationRequest({
        createtype: { value: createtypeValue, sort: e?.isAsc ? "asc" : "desc" },
        pageNo: 0,
      })
    );
  };
  const handleLocTypeFilterReset = () => {
    dispatch(
      updatePaginationRequest({
        createtype: { value: "", sort: "" },
        pageNo: 0,
      })
    );
  };

  const handleAddressReset = () => {
    setAddress("");
    //dispatch(fetchRequest());
    dispatch(
      updatePaginationRequest({
        address: { value: "", sort: "" },
        pageNo: 0,
      })
    );
  };

  const handleSearchAddress = (e) => {
    setAsc(e?.isAsc);
    //setAddress(e?.filteredResult);
    dispatch(
      updatePaginationRequest({
        address: { value: e?.filters?.text ? e?.filters?.text : "", sort: null },
        pageNo: 0,
      })
    );
  };
  const handleOrgCreatedAdd = () => {
    dispatch(searchPopUpUpdate(false));
    setOrgPopupVisible(false);
    dispatch(fetchRequest());
  };
  const handleDownload = () => {
    try {
      dispatch(downloadRequest("locationList"));
      setNotificationProps({
        type: "success",
        message: "Export",
        description: "Export completed successfully.",
        duration: 1,
        style: { backgroundColor: "#d4edda", color: "#155724" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 1000);
    } catch (error) {
      setNotificationProps({
        type: "error",
        message: "Export",
        description: error.message || "Unable to serialize unrecognized input.",
        duration: 5,
        style: { backgroundColor: "#FFECE0", color: "black" },
      });
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 3000);
    }
  };
  const closeorgPopup = () => {
    dispatch(searchPopUpUpdate(false));
    setOrgPopupVisible(false);
  };
  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;
    dispatch(updatePaginationRequest({
      limit: 10,
      createtype: { value: "", sort: "" },
      pageNo: 0,
    }));
    if (state?.hasOwnProperty("address") && state?.createlocation !== true) {
      setAddress([state?.address]);
    }
    const selectedOrgName = resultState ? (resultState?.name ?? "") : "";
    const currentName = (selectedOrgName || searchLoc || "").trim();

    if (currentName.length > 0) {
      setSearchLocName(currentName);
      dispatch(updatePaginationRequest({
        limit: 10,
        createtype: { value: "", sort: "" },
        name: { value: currentName, sort: "" },
        pageNo: 0,
      }));
    }
    setOrgPopupVisible(searchPopUpData);
    setSelectedOrganization(resultState);
    dispatch(fetchRequest());
    setSearchLocName("");
  }, [state?.address, state?.createlocation, searchLoc, searchPopUpData, user?.accountId]);
  useEffect(() => {
    if (!didInit.current || !resultState) return;

    const selectedOrgName = resultState.name ?? "";
    if (selectedOrgName.trim().length > 0) {
      setSearchLocName(selectedOrgName);
      dispatch(updatePaginationRequest({
        name: { value: selectedOrgName, sort: "" },
        pageNo: 0,
      }));
    }
  }, [resultState]);

  useEffect(() => {
    if (!didInit.current) return;
    dispatch(fetchRequest());
  }, [shouldUpdate, dispatch]);

  const sortedData = locationList?.sort((a, b) => {
    const orgA = a?.tags?.[0]?.name?.toLowerCase() || "";
    const orgB = b?.tags?.[0]?.name?.toLowerCase() || "";

    if (isAsc === true) {
      return orgA < orgB ? -1 : orgA > orgB ? 1 : 0;
    } else if (isAsc === false) {
      return orgA > orgB ? -1 : orgA < orgB ? 1 : 0;
    }
  });

  const filteredData = sortedData?.filter((item) => {
    let locName = "";
    let addressVal = "";
    if (Array.isArray(item?.tags) && item?.tags?.length > 0) {
      locName = item?.tags[0]?.name?.toLowerCase();
      addressVal = item?.tags[0]?.address?.toLowerCase();
    } else {
      locName = item?.name?.toLowerCase();
      addressVal = item?.address?.toLowerCase();
    }

    if (!locName) {
      return false;
    }
    let combinedBool = true;

    if (searchLocName?.length > 0) {
      const searchTerms = Array.isArray(searchLocName)
        ? searchLocName
        : [searchLocName];
      if (
        !searchTerms.some((searchTerm) =>
          locName?.includes(searchTerm?.toLowerCase())
        )
      ) {
        combinedBool = combinedBool && false;
      }
    }

    if (searchAddress?.length > 0) {
      const searchTerms = Array.isArray(searchAddress)
        ? searchAddress
        : [searchAddress];

      if (
        !searchTerms.some((searchTerm) =>
          addressVal?.includes(searchTerm?.toLowerCase())
        )
      ) {
        combinedBool = combinedBool && false;
      }
    }

    return combinedBool;
  });

  let dummyData = [];
  filteredData?.map((val, index) => {
    if (val.kind === "ts.tag.site") {
      dummyData.push({
        key: val?.id,
        name: val,
        type: val?.loc_type,
        address: val?.loc_type,
        value: val,
        warningCount: alarmCounts[val?.id]?.warningCount,
        errorCount: alarmCounts[val?.id]?.errorCount,
        action: (
          <Dropdown
            overlay={
              <Menu
                style={{
                  background: "transparent",
                  boxShadow: "none",
                  padding: 0,
                  border: "none",
                }}
              >
                <Menu.Item
                  style={{
                    padding: 0,
                    margin: 0,
                    background: "transparent",
                    border: "none",
                  }}
                >
                  <ul
                    className="dropdown-menu text-capitalize show"
                    style={{
                      position: "static",
                      background: "#fff",
                      padding: "8px 0",
                      margin: 0,
                      border: "1px solid rgba(0,0,0,0.15)",
                      borderRadius: "4px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      minWidth: "200px",
                      transform: "none !important",
                    }}
                  >
                    <li>
                      <span
                        className="font-face-vzw ats-filter-header"
                        style={{ marginLeft: "5px" }}
                      >
                        Actions
                      </span>
                    </li>

                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => editLocation(val)}
                      >
                        <h6>Edit Location</h6>
                      </li>
                    )}
                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => cloneLocation(val)}
                      >
                        <h6>Clone Location</h6>
                      </li>
                    )}

                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => deleteLocation(val)}
                      >
                        <h6>Delete Location</h6>
                      </li>
                    )}
                  </ul>
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
            placement="bottomRight"
            getPopupContainer={(trigger) => trigger.parentElement}
            overlayStyle={{
              position: "fixed",
            }}
          >
            <a
              className="btn btn-link text-secondary"
              role="button"
              onClick={(e) => e.preventDefault()}
              style={{ position: "relative" }}
            >
              <i className="bi-three-dots-vertical fs-6" />
            </a>
          </Dropdown>
        ),
      });
    } else if (val?.tags !== undefined && val.tags[0].kind === "ts.tag.site") {
      dummyData.push({
        key: val?.id,
        name: val?.tags !== undefined && val.tags[0],
        type: val?.tags[0]?.loc_type,
        address: val?.tags[0]?.loc_type,
        value: val,
        warningCount: alarmCounts[val?.id]?.warningCount,
        errorCount: alarmCounts[val?.id]?.errorCount,
        action: (
          <Dropdown
            overlay={
              <Menu
                style={{
                  background: "transparent",
                  boxShadow: "none",
                  padding: 0,
                  border: "none",
                }}
              >
                <Menu.Item
                  style={{
                    padding: 0,
                    margin: 0,
                    background: "transparent",
                    border: "none",
                  }}
                >
                  <ul
                    className="dropdown-menu text-capitalize show"
                    style={{
                      position: "static",
                      background: "#fff",
                      padding: "8px 0",
                      margin: 0,
                      border: "1px solid rgba(0,0,0,0.15)",
                      borderRadius: "4px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      minWidth: "200px",
                      transform: "none !important",
                    }}
                  >
                    <li>
                      <span
                        className="font-face-vzw ats-filter-header"
                        style={{ marginLeft: "5px" }}
                      >
                        Actions
                      </span>
                    </li>

                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => editLocation(val)}
                      >
                        <h6>Edit Location</h6>
                      </li>
                    )}
                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => cloneLocation(val)}
                      >
                        <h6>Clone Location</h6>
                      </li>
                    )}

                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => deleteLocation(val)}
                      >
                        <h6>Delete Location</h6>
                      </li>
                    )}
                  </ul>
                </Menu.Item>
              </Menu>
            }
            trigger={["click"]}
            placement="bottomRight"
            getPopupContainer={(trigger) => trigger.parentElement}
            overlayStyle={{
              position: "fixed",
            }}
          >
            <a
              className="btn btn-link text-secondary"
              role="button"
              onClick={(e) => e.preventDefault()}
              style={{ position: "relative" }}
            >
              <i className="bi-three-dots-vertical fs-6" />
            </a>
          </Dropdown>
        ),
      });
    }
  });
  const onConfirm = async () => {
    const response = await fetch(deleteLocationEndPoint(), {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
        "VZ-M2M-Token": getRandomUUID(),
      },
      body: JSON.stringify({
        accountName: sessionStorage.getItem("accountId"),
        tagId: selectedOrganization?.id,
      }),
    });
    const deleteLocationRsp = await response;
    if (deleteLocationRsp) {
      if (
        deleteLocationRsp?.status === 200 ||
        deleteLocationRsp?.status === 204
      ) {
        setNotificationProps({
          type: "success",
          message: "Delete Location",
          description: `Location "${selectedOrganization?.name ||
            selectedOrganization?.tags[0]?.name ||
            ""
            }" deleted successfully`,
          duration: 1,
          style: { backgroundColor: "#d4edda", color: "#155724" },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
        handleOrgCreatedAdd();
        dispatch(setCurrentModal(false));
      } else {
        setNotificationProps({
          type: "error",
          message: "Delete Location",
          description: "failed",
          duration: 1,
          style: { backgroundColor: "#FFECE0", color: "#155724" },
        });
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
        }, 1000);
        handleOrgCreatedAdd();
        dispatch(setCurrentModal(false));
      }
    }
  };
  const deleteLocation = (record) => {
    setSelectedOrganization(record);
    dispatch(setCurrentModal(true));
  };

  const onExit = () => {
    dispatch(setCurrentModal(false));
    //navigate(-1);
  };

  const locationTypeOptions = [
    { text: "Inventory", value: "" },
    { text: "Shipment", value: "" },
  ];

  const columns = [
    {
      title: (
        <div>
          <div
            className="input-group input-group-sm d-flex"
            data-controller="qrcode-reader"
            data-action="qrcode:scanned->form#submit"
          >
            <DropdownFilterWithSearch
              text="Location name"
              isSortable={true}
              accountId={user?.accountId}
              onApply={handleSearchLocName}
              onReset={handleLocFilterReset}
            />
          </div>
        </div>
      ),
      dataIndex: "name",
      width: "30%",
      render: (text, record, index) => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h6 className="mb-0 fw-bold">
                <button
                  className="custom-link"
                  onClick={() =>
                    permissions?.Locations?.edit
                      ? locationDetails(record?.value)
                      : null
                  }
                >
                  {text?.name}
                </button>
              </h6>
            </div>
          </div>
        );
      },
      SortOrder: "assend",
    },
    {
      title: (
        <DropdownFilterWithSearchAndCheckbox
          text="Location type"
          accountId={user?.accountId}
          isSortable={true}
          onApply={handleLocTypeChange}
          onReset={handleLocTypeFilterReset}
          checkboxItems={locationtype.option}
        // checkboxItems={locationTypeOptions}
        />
      ),
      dataIndex: "createtype",
      width: "30%",
      render: (text, record, index) => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <p className="mb-0">{record.value?.createtype === "inventory_location" ? "Inventory" : "Shipment"}</p>
            </div>
          </div>
        );
      },
      SortOrder: "assend",
    },
    {
      title: (
        <div>
          <div
            className="input-group input-group-sm d-flex"
            data-controller="qrcode-reader"
            data-action="qrcode:scanned->form#submit"
          >
            <DropdownFilterWithSearch
              text="Address"
              isSortable={false}
              accountId={user?.accountId}
              onApply={handleSearchAddress}
              onReset={handleAddressReset}
            />
          </div>
        </div>
      ),
      dataIndex: "",
      width: "70%",
      render: (text, record, index) => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <p className="mb-0">{text?.name?.address}</p>
            </div>
          </div>
        );
      },
    },
    {
      title: (
        <>
          <br />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: "8px",
            }}
          >
            <Dropdown
              trigger={["click"]}
              overlay={
                <div
                  style={{
                    background: "#fff",
                    padding: "8px 0",
                    border: "1px solid rgba(0,0,0,0.15)",
                    borderRadius: "4px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    minWidth: "200px",
                  }}
                >
                  <div>
                    <span className="font-face-vzw ats-filter-header">
                      Action
                    </span>
                  </div>
                  {permissions?.Locations?.download ? (
                    <div
                      style={{
                        padding: "8px 12px",
                        cursor: "pointer",
                        ":hover": {
                          backgroundColor: "rgba(0,0,0,0.04)",
                        },
                      }}
                      onClick={handleDownload}
                    >
                      Export
                    </div>
                  ) : null}
                </div>
              }
            >
              <button
                className="btn btn-link text-secondary"
                onClick={(e) => e.preventDefault()}
              >
                <i className="bi-three-dots-vertical fs-6" />
              </button>
            </Dropdown>
          </div>
        </>
      ),
      width: "20%",
      align: "right",
      render: (_, record) => (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "8px",
          }}
        >
          <Dropdown
            trigger={["click"]}
            placement="bottomRight"
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
            overlay={
              <Menu
                style={{
                  background: "transparent",
                  boxShadow: "none",
                  padding: 0,
                  border: "none",
                }}
              >
                <Menu.Item
                  style={{
                    padding: 0,
                    margin: 0,
                    background: "transparent",
                    border: "none",
                  }}
                >
                  <ul
                    className="dropdown-menu text-capitalize show"
                    style={{
                      position: "static",
                      background: "#fff",
                      padding: "8px 0",
                      margin: 0,
                      border: "1px solid rgba(0,0,0,0.15)",
                      borderRadius: "4px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      minWidth: "200px",
                    }}
                  >
                    {/* <li>
                      <span
                        className="font-face-vzw ats-filter-header"
                        style={{ marginLeft: "5px" }}
                      >
                        Links
                      </span>
                    </li>

                    {permissions?.assets?.view && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                      >
                        <Link
                          to="/assets"
                          state={{
                            org_name: record.value?.tags?.[0]?.org_name,
                            org_Id: record.value?.tags?.[0]?.orgId,
                            location: record.value?.tags?.[0]?.name,
                            location_Id: record.value?.id,
                          }}
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                            display: "block",
                          }}
                        >
                          View Assets
                        </Link>
                      </li>
                    )}

                    {permissions?.devices?.view && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                      >
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/devices", {
                              state: {
                                org_name: record.value?.tags?.[0]?.org_name,
                                org_Id: record.value?.tags?.[0]?.orgId,
                                location: record.value?.tags?.[0]?.name,
                                location_Id: record.value?.id,
                              },
                            });
                          }}
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                            display: "block",
                          }}
                        >
                          View Devices
                        </Link>
                      </li>
                    )}

                    {permissions?.alarms?.view && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                      >
                        <Link
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/alerts", {
                              state: {
                                location: record.value?.tags[0]?.name,
                              },
                            });
                          }}
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                            display: "block",
                          }}
                        >
                          View Alerts
                        </Link>
                      </li>
                    )} */}

                    <li>
                      {/* <hr
                        className="dropdown-divider"
                        style={{ margin: "8px 0" }}
                      /> */}
                      <span
                        className="font-face-vzw ats-filter-header"
                        style={{ marginLeft: "5px" }}
                      >
                        Actions
                      </span>
                    </li>

                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => editLocation(record.value)}
                      >
                        Edit Location
                      </li>
                    )}
                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => cloneLocation(record.value)}
                      >
                        Clone Location
                      </li>
                    )}

                    {permissions?.Locations?.edit && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                        onClick={() => deleteLocation(record.value)}
                      >
                        Delete Location
                      </li>
                    )}

                    {/* {permissions?.devices?.create && (
                      <li
                        className="dropdown-item"
                        style={{ background: "transparent" }}
                      >
                        <Link
                          to="/devices"
                          state={{ addNewdevice: true }}
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                            display: "block",
                          }}
                        >
                          Add Devices
                        </Link>
                      </li>
                    )} */}
                  </ul>
                </Menu.Item>
              </Menu>
            }
          >
            <button
              className="btn btn-link text-secondary"
              onClick={(e) => e.preventDefault()}
            >
              <i className="bi-three-dots-vertical fs-6" />
            </button>
          </Dropdown>
        </div>
      ),
      width: 50,
      dataIndex: "action",
    },
  ];

  return (
    <Box
      sx={{
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        borderTopWidth: 0,
      }}
      style={{
        backgroundColor: "#fff",
        borderRadius: "12px",
      }}
    >
      {(orgPopupVisible && current_modal != 'inventory_location') && (
        <CreateLocation
          visible={orgPopupVisible}
          closePopup={closeorgPopup}
          state={location_data?.action_type === 'edit' ? location_data : selectedOrganization}
          editConfirm={editConfirm}
          setEditConfirm={setEditConfirm}
          selectedCloneOrganization={selectedCloneOrganization}
          onOrgCreated={handleOrgCreatedAdd}
        />
      )}
      {
        inventoryLocationView && <InventoryLocationView visible={inventoryLocationView} inventoryLocationData={inventoryLocationData} closePopup={() => setInventoryLocationView(false)} />
      }
      {showNotification && (
        <ToastNotification
          type={notificationProps.type}
          message={notificationProps.message}
          description={notificationProps.description}
          duration={notificationProps.duration}
          style={notificationProps.style}
        />
      )}
      <CustomModal
        popupName={""}
        customClass={"deleteAlertGroup"}
        popupTitle={"Delete location"}
        open={currentModal}
      >
        <>
          <p style={{ padding: "5px", marginTop: "25px", paddingLeft: "0px" }}>
            Are you sure you’d like to delete the location{" "}
            <strong>
              {selectedOrganization?.name ||
                selectedOrganization?.tags?.[0]?.name}
            </strong>
            ?
          </p>
          <Grid2
            container
            marginTop={1}
            marginBottom={0}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  shape="round"
                  style={{
                    fontWeight: "bold",
                    width: "100%",
                    backgroundColor: "white",
                    color: "black",
                  }}
                  onClick={() => onExit()}
                  size={"large"}
                >
                  No, cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-3">
                <Button
                  className="custom-button-save"
                  type="primary"
                  shape="round"
                  onClick={() => {
                    onConfirm();
                  }}
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Yes, delete
                </Button>
              </div>
            </Grid2>
          </Grid2>
        </>
      </CustomModal>
      <Table
        style={{ marginTop: "24px" }}
        className="sasp_common-table"
        loading={isLoading}
        columns={columns}
        dataSource={dummyData}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          pageSizeOptions: ["10", "20", "50", "100"],
          total: count,
          showTotal: (total, range) =>
            `Showing ${range[0]} - ${range[1]} of ${total}`,
          position: ["bottomRight"],
          prevIcon: ["Previous"],
          nextIcon: ["Next"],
          onChange: (page, pageSize) => {
            dispatch(
              updatePaginationRequest({
                limit: pageSize == -1 ? 10 : pageSize,
                pageNo: page - 1,
              })
            );
          },
          showSizeChanger: true,
          locale: {
            items_per_page: "",
          },
        }}
      />
    </Box>
  );
};

export default LocationTable;
